/*why-this-error-occurred*/
/*solution*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "不必要的包任务语法错误",
  "description": "了解更多关于 Turborepo 中不必要的包任务语法的错误信息。"
};
export let structuredData = {
  "contents": [{
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "¥Why this error occurred"
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "Turborepo 支持在包目录中添加额外的 turbo.json 文件来覆盖在仓库根目录下声明的 turbo.json 文件，这项功能称为 工作区配置。在这些附加的 turbo.json 文件中，你只能为该特定包配置任务。因此，任务中只能包含任务名称，而不能包含包和任务名称 (package#task)。"
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "¥Turborepo supports adding additional turbo.json files in a package directory\nto override the turbo.json file declared at the repository root, a feature called Workspace Configurations.\nIn those additional turbo.json files, you can only configure tasks for that specific\npackage. Therefore, only the task name should be included in the task,\nnot the package and task name (package#task)."
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "apps/web 目录中的 turbo.json 文件："
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "¥turbo.json file in apps/web directory:"
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "由于此 turbo.json 文件位于软件包目录中，因此无需使用 web 前缀。"
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "¥Since this turbo.json file is inside a package directory, the web prefix is unnecessary."
  }, {
    "heading": "解决方案-solution",
    "content": "¥Solution"
  }, {
    "heading": "解决方案-solution",
    "content": "从任务名称中删除软件包前缀："
  }, {
    "heading": "解决方案-solution",
    "content": "¥Remove the package prefix from the task name:"
  }],
  "headings": [{
    "id": "为什么会出现此错误-why-this-error-occurred",
    "content": "为什么会出现此错误 /*why-this-error-occurred*/"
  }, {
    "id": "解决方案-solution",
    "content": "解决方案 /*solution*/"
  }]
};
export const toc = [{
  depth: 2,
  url: "#为什么会出现此错误-why-this-error-occurred",
  title: _jsx(_Fragment, {
    children: "为什么会出现此错误 "
  })
}, {
  depth: 2,
  url: "#解决方案-solution",
  title: _jsx(_Fragment, {
    children: "解决方案 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "为什么会出现此错误-why-this-error-occurred",
      children: "为什么会出现此错误 "
    }), "\n", _jsx(_components.p, {
      children: "¥Why this error occurred"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 支持在包目录中添加额外的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 文件来覆盖在仓库根目录下声明的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 文件，这项功能称为 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/structuring-a-repository#specifying-packages-in-a-monorepo",
        children: "工作区配置"
      }), "。在这些附加的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 文件中，你只能为该特定包配置任务。因此，任务中只能包含任务名称，而不能包含包和任务名称 (", _jsx(_components.code, {
        children: "package#task"
      }), ")。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo supports adding additional ", _jsx(_components.code, {
        children: "turbo.json"
      }), " files in a package directory\nto override the ", _jsx(_components.code, {
        children: "turbo.json"
      }), " file declared at the repository root, a feature called ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/structuring-a-repository#specifying-packages-in-a-monorepo",
        children: "Workspace Configurations"
      }), ".\nIn those additional ", _jsx(_components.code, {
        children: "turbo.json"
      }), " files, you can only configure tasks for that specific\npackage. Therefore, only the task name should be included in the task,\nnot the package and task name (", _jsx(_components.code, {
        children: "package#task"
      }), ")."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "apps/web"
      }), " 目录中的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 文件："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo.json"
      }), " file in ", _jsx(_components.code, {
        children: "apps/web"
      }), " directory:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"web#build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["由于此 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 文件位于软件包目录中，因此无需使用 ", _jsx(_components.code, {
        children: "web"
      }), " 前缀。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Since this ", _jsx(_components.code, {
        children: "turbo.json"
      }), " file is inside a package directory, the ", _jsx(_components.code, {
        children: "web"
      }), " prefix is unnecessary."]
    }), "\n", _jsx(_components.h2, {
      id: "解决方案-solution",
      children: "解决方案 "
    }), "\n", _jsx(_components.p, {
      children: "¥Solution"
    }), "\n", _jsx(_components.p, {
      children: "从任务名称中删除软件包前缀："
    }), "\n", _jsx(_components.p, {
      children: "¥Remove the package prefix from the task name:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
